/* Scroll-reveal (fade-up) animation — homepage scroll interactivity (Issue 2, Aug 2026)
   Progressive enhancement only: elements are never hidden until this script marks them,
   so nothing breaks if JS fails to load, and prefers-reduced-motion users see no animation. */
(function () {
  if (typeof window === 'undefined') return;

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  if (!('IntersectionObserver' in window)) return;

  var REVEAL_CLASS = 'hb-reveal';
  var VISIBLE_CLASS = 'hb-reveal--visible';
  var STAGGER_MS = 50;
  var MAX_GRID_ITEMS = 4; // "first row" of a product/collection grid

  function markAndObserve(el, delayMs, observer) {
    if (!el || el.classList.contains(REVEAL_CLASS)) return;
    el.classList.add(REVEAL_CLASS);
    if (delayMs) el.style.setProperty('--hb-reveal-delay', delayMs + 'ms');
    observer.observe(el);
  }

  function init() {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add(VISIBLE_CLASS);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -10% 0px' }
    );

    // Announcement bar — header chrome, above the fold. It's already in the
    // initial viewport on load, so observing it gives a quick fade-up-into-
    // place on page load rather than a true scroll trigger, using the same
    // transition as the rest of the page for a consistent feel.
    var announcementBar = document.querySelector('.announcement-bar');
    if (announcementBar) {
      markAndObserve(announcementBar, 0, observer);
    }

    // Scope to homepage content only — this excludes the header and footer
    // chrome (which live outside <main id="MainContent">), so things like
    // the currency-selector button never get mistaken for a section heading.
    var sections = document.querySelectorAll('#MainContent .shopify-section');

    sections.forEach(function (section) {
      // Skip the hero — it's above the fold and has its own presentation.
      if (section.querySelector('.hero')) return;

      // 1) Section heading inside the theme's generic resource-list header
      //    (product grids, collection grids).
      var headerHeading = section.querySelector(
        '.section-resource-list__header h1, .section-resource-list__header h2, .section-resource-list__header h3, .section-resource-list__header h4, .section-resource-list__header h5'
      );
      if (headerHeading) {
        markAndObserve(headerHeading, 0, observer);
      } else {
        // 2) Fallback: first heading-styled text block in the section that
        //    isn't inside a product/collection/blog card, and isn't part of
        //    an icon-column row (handled as its own unit in step 4 below).
        var candidates = section.querySelectorAll(
          '[class~="h1"], [class~="h2"], [class~="h3"], [class~="h4"], [class~="h5"]'
        );
        for (var i = 0; i < candidates.length; i++) {
          var candidate = candidates[i];
          if (
            !candidate.closest('.product-card, .collection-card, .blog-post-card') &&
            !candidate.closest('.group-block')
          ) {
            markAndObserve(candidate, 0, observer);
            break;
          }
        }
      }

      // 3) First row of product/collection cards.
      var cards = section.querySelectorAll('.product-card, .collection-card');
      var count = 0;
      cards.forEach(function (card) {
        if (count >= MAX_GRID_ITEMS) return;
        markAndObserve(card, count * STAGGER_MS, observer);
        count++;
      });

      // 4) Icon-column rows — e.g. the "Legacy Since 1969 / True Gaddi
      //    Prices / Guided Buying" trust bar: a flex row whose direct
      //    children are 2+ "group-block" columns (icon + heading + text).
      //    Reveal each column as one unit, staggered like a grid.
      var iconRows = section.querySelectorAll('.layout-panel-flex--row');
      iconRows.forEach(function (row) {
        var columns = Array.prototype.filter.call(row.children, function (child) {
          return child.classList.contains('group-block');
        });
        if (columns.length < 2) return;
        columns.forEach(function (column, colIndex) {
          markAndObserve(column, colIndex * STAGGER_MS, observer);
        });
      });
    });
  }

  // Wait for full page load (not just DOMContentLoaded) before measuring
  // positions — this avoids a race where images/video still loading cause a
  // layout shift right after the observer starts, which can make the very
  // first section's elements appear to be in-view for a moment and skip
  // their fade-in. A short extra delay lets that initial layout settle.
  function start() {
    setTimeout(init, 100);
  }

  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', start);
  }
})();
